module.exports = __webpack_public_path__ + "img/phone.a0b6b970.svg";